import { useCallback } from 'react';

import { useFeedback } from '@/components/notifications/Feedback/useFeedback';
import { useReportError } from '@/hooks/useReportError';

import { useDeleteMemoMutation } from '../graphql/DeleteMemo.generated';

export function useDeleteMemo() {
  const { showFeedback } = useFeedback();
  const { reportError } = useReportError();
  const [deleteMemoMutation, { loading }] = useDeleteMemoMutation();

  const deleteMemo = useCallback(
    async (memoId: string): Promise<boolean> => {
      try {
        await deleteMemoMutation({
          variables: {
            id: memoId,
          },
          refetchQueries: 'active',
          awaitRefetchQueries: true,
        });

        showFeedback('Memo deleted successfully', {
          variant: 'success',
        });

        return true;
      } catch (error) {
        showFeedback(
          'Failed to delete this memo. Please refresh the page and try again.'
        );
        reportError(
          'Failed to delete memo',
          error instanceof Error ? error : new Error('Unknown delete error'),
          { memoId }
        );

        return false;
      }
    },
    [deleteMemoMutation, reportError, showFeedback]
  );

  return {
    deleteMemo,
    loading,
  };
}
